import type { EscPosProfile } from './escpos/encodeReceipt';
import type { BleTransportDiagnostics } from './transports/WebBluetoothTransport';
import { isIsscBleUnreliable } from './printerTransportAdvice';

/**
 * XP-P203A ESC/POS profile for the active transport.
 * ISSC BLE without credit notifies → standard ESC/POS + GS V cut (not feed-only ISSC flush).
 * USB serial → always standard xp-p203a.
 */
export function resolveXpP203aEscPosProfile(opts: {
  transportKind: 'ble' | 'serial' | null;
  bleDiagnostics: BleTransportDiagnostics | null;
}): EscPosProfile {
  if (opts.transportKind === 'serial') {
    return 'xp-p203a';
  }
  const ble = opts.bleDiagnostics;
  if (ble?.bridgeProfile === 'issc') {
    if (isIsscBleUnreliable(ble)) {
      return 'issc-cut';
    }
    return 'issc';
  }
  return 'xp-p203a';
}
